module.exports = __webpack_public_path__ + "img/SketchPng4525466793936f50253662e96361e237b02778b04f46df7ff66794244c163ade.197c9942.png";